package at.apa.statistictracker.data.model

import kotlinx.serialization.json.JsonElement

data class StatisticPayload(
    val id: Long,
    val payload: JsonElement,
    val timestampInUnixMillis: Long,
) {
    constructor(payload: JsonElement, timestampInUnixMillis: Long) : this(-1, payload, timestampInUnixMillis)
}
